import Base from "./base";
import Password from "./password";

export default function Field(props) {
	const Cmp = getCmp(props);
	return <Cmp {...props} />;
}

function getCmp({ content }) {
	if (content === 'password') return Password;
	return Base;
}